<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small"
                 class="query-form" @submit.native.prevent>
            <el-form-item label="门店">
<!--                <el-input v-model="queryForm.storeId"></el-input>-->
                <GridSelectShop
                    style="width: 200px"
                    title="选择所属门店"
                    labelName="storeName"
                    labelValue="id"
                    :value="queryForm.storeId"
                    :limit="1"
                    size="small"
                    @getValue="getValueShopId"
                    :columns="STORE_code"
                    :searchs="STORE_search"
                    dataListUrl="/shop/store/findList"
                    entityBeanName="shopStore"
                    queryEntityUrl="/shop/store/get"
                >
                </GridSelectShop>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getShopStorePayChannelList">查询
                </el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <el-button
                        type="primary"
                        size="small"
                        icon="el-icon-plus"
                        @click="addShopStorePayChannel"
                    >新建
                    </el-button>
                    <el-button
                        type="warning"
                        plain
                        size="small"
                        icon="el-icon-edit"
                        :disabled="multipleSelection.length != 1"
                        @click="editShopStorePayChannel(null)"
                    >修改
                    </el-button>
                    <el-button
                        type="danger"
                        plain
                        size="small"
                        icon="el-icon-delete"
                        :disabled="multipleSelection.length <= 0"
                        @click="deleteShopStorePayChannel(null)"
                    >删除
                    </el-button>
                </div>

                <div class="icon-group">
                    <el-upload v-if="this.isImportDate"
                               class="upload-demo"
                               action="#"
                               :http-request="upload"
                               :show-file-list="true">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
                    <span
                        title="搜索"
                        class="icon-box"
                        @click="search"
                    >
                      <Icon color="#606266">
                        <Search />
                      </Icon>
                    </span>
<!--                    <span-->
<!--                        title="下载模板"-->
<!--                        class="icon-box"-->
<!--                        @click="importTemplate"-->
<!--                    >-->
<!--                      <Icon color="#606266">-->
<!--                        <ArrowDown />-->
<!--                      </Icon>-->
<!--                    </span>-->
<!--                    <span-->
<!--                        class="icon-box"-->
<!--                        title="导入数据"-->
<!--                        @click="isImport"-->
<!--                    >-->
<!--                      <Icon color="#606266">-->
<!--                        <ArrowExportUp24Regular />-->
<!--                      </Icon>-->
<!--                    </span>-->
<!--                    <span-->
<!--                        title="导出数据"-->
<!--                        class="icon-box"-->
<!--                        @click="exportShopStorePayChannelList"-->
<!--                    >-->
<!--                      <Icon color="#606266">-->
<!--                        <ArrowDownload24Regular />-->
<!--                      </Icon>-->
<!--                    </span>-->
                    <span
                        class="icon-box"
                        @click="refreshShopStorePayChannelList"
                    >
                      <Icon color="#606266">
                        <Refresh />
                      </Icon>
                    </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :data="shopStorePayChannelList"
                row-key="id"
                border
                height="100%"
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                @selection-change="handleSelectionChange"
                size="small"
            >
                <el-table-column
                    align="center"
                    type="selection"
                    width="60"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="storeId"
                    label="门店信息"
                >
                    <template slot-scope="scope">
                        <div v-if="scope.row.store">
                            <div style="text-align: left">店名：{{scope.row.store.storeName}}</div>
                            <div style="text-align: left">时间：{{scope.row.store.openHours}}</div>
                            <div style="text-align: left">地址：{{scope.row.store.storeAddress}}</div>
                        </div>
                        <div v-else>暂无关联店铺</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="orginfoId"
                    label="进件信息"
                >
                    <template scope="scope">
                        <div v-if="scope.row.orginfo">
                            <div style="text-align: left">法人：{{ scope.row.orginfo.personName }}</div>
                            <div style="text-align: left">法人手机号：{{ scope.row.orginfo.personMobile }}</div>
                            <div style="text-align: left">营业执照名称：{{ scope.row.orginfo.licenseName }}</div>
                        </div>
                        <div v-else>暂无进件信息</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="channelId"
                    label="支付渠道信息"
                >
                    <template slot-scope="scope">

                        <!--                        <div style="text-align: left">汇付支付审核状态：<span :class="{'active': scope.row.thirdStatus == 2}">{{computeAuditStatus(scope.row.thirdStatus) }}</span></div>-->
                        <div style="text-align: left">微信支付开通状态：<span :class="{'active': scope.row.openWxpay == 1}">{{ scope.row.openWxpay == 1 ? '已开通' : '未开通' }}</span></div>
                        <div style="text-align: left">支付宝支付开通状态：<span :class="{'active': scope.row.openAlipay == 1}">{{ scope.row.openAlipay == 1 ? '已开通' : '未开通' }}</span></div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="channelType"
                    label="支付渠道类型"
                >
                    <template slot-scope="scope">
                        {{ returnChanelTypeStatus(scope.row.channelType) }}
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="isActivate"
                    label="是否激活"
                >
                    <template slot-scope="scope">
                        {{ scope.row.isActivate == 1 ? '是' : '否' }}
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="isShow"
                    label="是否显示"
                >
                    <template slot-scope="scope">
                        {{ scope.row.isShow == 1 ? '是' : '否' }}
                    </template>
                </el-table-column>
                <el-table-column
                    fixed="right"
                    align="center"
                    label="操作"
                    width="300"
                >
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click="checkShopStorePayChannel(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">查看</span>
                            </div>
                            <div @click="editShopStorePayChannel(scop.row.id)">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">修改</span>
                            </div>
                            <div @click="deleteShopStorePayChannel(scop.row.id)">
                                <Icon size="16" style="color: red">
                                    <Delete24Regular />
                                </Icon>
                                <span class="operation-label" style="color: red">删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title="shopStorePayChannelStates[shopStorePayChannelState]"
                :visible.sync="showDialog"
                width="60%"
                @close="closeDialog"
            >
                <div>
                    <el-form
                        :model="shopStorePayChannel"
                        ref="shopStorePayChannelForm"
                        :rules="rules"
                        label-width="120px"
                        :inline="true"
                        size="small"
                    >
                        <el-form-item
                            label="门店"
                            prop="storeId"
                        >
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                style="width: 200px;"-->
<!--                                v-model="shopStorePayChannel.storeId"-->
<!--                                :disabled="shopStorePayChannelState == 'check'"-->
<!--                            ></el-input>-->
                            <GridSelectShop
                                style="width: 200px"
                                title="选择所属门店"
                                labelName="storeName"
                                labelValue="id"
                                :resultObj="true"
                                :value="shopStorePayChannel.storeId"
                                :limit="1"
                                size="small"
                                @getValue="getSearchValueShopId"
                                :columns="STORE_code"
                                :searchs="STORE_search"
                                dataListUrl="/shop/store/findList"
                                entityBeanName="shopStore"
                                queryEntityUrl="/shop/store/get"
                            >
                            </GridSelectShop>
                        </el-form-item>
<!--                        <el-form-item-->
<!--                            label="商户信息"-->
<!--                            prop="orginfoId"-->
<!--                        >-->
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                style="width: 200px;"-->
<!--                                v-model="shopStorePayChannel.orginfoId"-->
<!--                                :disabled="shopStorePayChannelState == 'check'"-->
<!--                            ></el-input>-->
<!--                        </el-form-item>-->
                        <el-form-item
                            label="支付渠道类型"
                            prop="channelType"
                        >
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                v-model="shopStorePayChannel.channelType"-->
<!--                                :disabled="shopStorePayChannelState == 'check'"-->
<!--                            ></el-input>-->
                            <el-select
                                size="small"
                                style="width: 200px;"
                                v-model="shopStorePayChannel.channelType"
                                :disabled="shopStorePayChannelState == 'check'"
                            >
                                <el-option
                                    v-for="item in enumList"
                                    :key="item.value"
                                    :label="item.value"
                                    :value="item.key"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="渠道信息"
                            prop="channelId"
                            v-if="shopStorePayChannel.channelType"
                        >
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                style="width: 200px;"-->
<!--                                v-model="shopStorePayChannel.channelId"-->
<!--                                :disabled="shopStorePayChannelState == 'check'"-->
<!--                            ></el-input>-->
                            <el-select
                                size="small"
                                style="width: 200px;"
                                v-model="shopStorePayChannel.channelId"
                                :disabled="shopStorePayChannelState == 'check'">
                                <el-option
                                    v-for="(item, index) in channelList"
                                    :key="index"
                                    :label="item.subAccount"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="是否激活"
                            prop="isActivate"
                        >
                            <el-select
                                size="small"
                                style="width: 200px;"
                                v-model="shopStorePayChannel.isActivate"
                                :disabled="shopStorePayChannelState == 'check'"
                            >
                                <el-option
                                    label="是"
                                    :value="1"
                                ></el-option>
                                <el-option
                                    label="否"
                                    :value="0"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="是否显示"
                            prop="isShow"
                        >
                            <el-select
                                size="small"
                                style="width: 200px;"
                                v-model="shopStorePayChannel.isShow"
                                :disabled="shopStorePayChannelState == 'check'"
                            >
                                <el-option
                                    label="是"
                                    :value="1"
                                ></el-option>
                                <el-option
                                    label="否"
                                    :value="0"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>

                <div
                    slot="footer"
                    class="flex justify-end"
                >
                    <el-button @click="closeDialog">关闭</el-button>
                    <el-button
                        type="primary"
                        @click="submitForm"
                        v-if="shopStorePayChannelState != 'check'"
                    >确定
                    </el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectShop from '@/components/gridselect/gidselect.vue';
import { STORE, STORE_SEARCH } from '@/utils/constant';

export default {
    components: {
        GridSelectShop,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetShopStorePayChannelList();
                this.getShopStorePayChannelList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetShopStorePayChannelList();
                this.getShopStorePayChannelList();
                this.$emit('resetCheckState');
            }
        },
        "shopStorePayChannel.channelType"(val){
            if(this.isGet){
                this.isGet = false
            }else{
                this.shopStorePayChannel.channelId = ''
            }
            this.getChannelList(val)
        }
    },
    data() {
        return {
            STORE_code: STORE,
            STORE_search: STORE_SEARCH,
            queryForm: {
                storeId: '', //门店id
                channelType: '', //支付渠道类型
                isActivate: '', //是否激活
                isShow: '', //是否显示
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            shopStorePayChannelState: 'add',
            shopStorePayChannelStates: {
                add: '新建支付渠道',
                check: '查看支付渠道',
                edit: '修改支付渠道'
            },

            multipleSelection: [],
            shopStorePayChannelList: [],
            shopStorePayChannel: {
                storeId: '', //门店id
                channelType: '', //支付渠道类型
                isActivate: '', //是否激活
                isShow: '', //是否显示
                orginfoId: '',
                channelId: ''
            },
            btnLoading: false,

            rules: {
                storeId: [{ required: true, message: '门店id不能为空', trigger: 'blur' }],
                channelType: [{ required: true, message: '支付渠道类型不能为空', trigger: 'blur' }],
                isActivate: [{ required: true, message: '是否激活不能为空', trigger: 'blur' }],
                isShow: [{ required: true, message: '是否显示不能为空', trigger: 'blur' }],
                orginfoId: [{ required: true, message: '商户信息id不能为空', trigger: 'blur' }],
                channelId: [{ required: true, message: '渠道信息id不能为空', trigger: 'blur' }]
            },

            enumList: [],
            channelList: [],
            isGet: false,
        };
    },
    created() {
        this.getShopStorePayChannelList();
        this.getEnum();
    },
    methods: {
        search() {
            this.isSearch = !this.isSearch;
        },
        getChannelList(val){
            if(val == 1){
                get("/shop/storepayyinsheng/findAll", { storeId: this.shopStorePayChannel.storeId, orginfoId: this.shopStorePayChannel.orginfoId }).then((res)=>{
                    if(res.success){
                        this.channelList = res.list
                    }
                })
            }else if(val == 2){
                get("/shop/storepayyisheng/findAll", { storeId: this.shopStorePayChannel.storeId, orginfoId: this.shopStorePayChannel.orginfoId }).then((res)=>{
                    if(res.success){
                        this.channelList = res.list
                    }
                })
            }else if(val == 3){
                get("/shop/storepayhuifu/findAll", { storeId: this.shopStorePayChannel.storeId, orginfoId: this.shopStorePayChannel.orginfoId }).then((res)=>{
                    if(res.success){
                        this.channelList = res.list
                    }
                })
            }else if(val == 3){
                get("/shop/storepayhuilian/findAll", { storeId: this.shopStorePayChannel.storeId, orginfoId: this.shopStorePayChannel.orginfoId }).then((res)=>{
                    if(res.success){
                        this.channelList = res.list
                    }
                })
            }
        },
        resetShopStorePayChannelList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopStorePayChannelList = [];
        },
        resetDialog() {
            this.shopStorePayChannelState = 'add';
            this.showDialog = false;
            this.queryForm = {
                storeId: '', //门店id
                channelType: '', //支付渠道类型
                isActivate: '', //是否激活
                isShow: '', //是否显示
            };
            this.getShopStorePayChannelList();
        },
        getEnum(){
            get(`/shop/utils/getEnum`, { enumType: 'pay_channel_type' }).then((res) => {
                if (res.success) {
                    this.enumList = res.enumList;
                }
            });
        },
        getValueShopId(val){
            this.queryForm.storeId = val;
        },
        getSearchValueShopId(val){
            console.log("???")
            this.shopStorePayChannel.storeId = val.id;
            this.shopStorePayChannel.orginfoId = val.orginfo ? val.orginfo.id : '';
            console.log(this.shopStorePayChannel.storeId, this.shopStorePayChannel.orginfoId)
        },
        returnChanelTypeStatus(key){
            for (let i = 0; i < this.enumList.length; i++) {
                if(this.enumList[i].key == key){
                    return this.enumList[i].value
                }
            }
        },
        closeDialog() {
            this.showDialog = false;
            this.shopStorePayChannel = {
                storeId: '', //门店id
                channelType: '', //支付渠道类型
                isActivate: '', //是否激活
                isShow: '', //是否显示
                orginfoId: '',
                channelId: ''
            };
        },
        submitForm() {
            if (this.shopStorePayChannelState == 'add') {
                this.$refs.shopStorePayChannelForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/shop/storepaychannel/add`, { ...this.shopStorePayChannel }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopStorePayChannelList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            } else if (this.shopStorePayChannelState == 'edit') {
                this.$refs.shopStorePayChannelForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        delete this.shopStorePayChannel.yishengMerch;
                        delete this.shopStorePayChannel.yinshengMerch;
                        delete this.shopStorePayChannel.huifuMerch;
                        delete this.shopStorePayChannel.huilianMerch;
                        delete this.shopStorePayChannel.store;
                        delete this.shopStorePayChannel.orginfo;
                        post(`/shop/storepaychannel/editOrActive`, { ...this.shopStorePayChannel }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopStorePayChannelList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            }
        },
        addShopStorePayChannel() {
            this.showDialog = true;
            this.shopStorePayChannelState = 'add';
        },
        checkShopStorePayChannel(shopStorePayChannelId) {
            console.log(shopStorePayChannelId);
            this.currentShopStorePayChannelId = shopStorePayChannelId;

            this.getShopStorePayChannelById();
            this.showDialog = true;
            this.shopStorePayChannelState = 'check';
        },
        editShopStorePayChannel(shopStorePayChannelId) {
            console.log('shopStorePayChannel', shopStorePayChannelId);
            if (shopStorePayChannelId) {
                this.currentShopStorePayChannelId = shopStorePayChannelId;
                this.getShopStorePayChannelById();
            } else {
                this.shopStorePayChannel = { ...this.shopStorePayChannel, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.shopStorePayChannelState = 'edit';
        },
        deleteShopStorePayChannel(shopStorePayChannelId) {
            let ids = '';
            if (shopStorePayChannelId) {
                ids = shopStorePayChannelId;
            } else {
                ids = this.multipleSelection.map((shopStorePayChannel) => shopStorePayChannel.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/shop/storepaychannel/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetShopStorePayChannelList();
                            this.getShopStorePayChannelList();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                })
                .catch(() => {
                });
        },
        refreshShopStorePayChannelList() {
            this.resetShopStorePayChannelList();
            this.getShopStorePayChannelList();
        },
        getShopStorePayChannelList(query = {}) {
            this.loading = true;
            get(`/shop/storepaychannel/findListOrOrg`, {
                ...this.queryForm,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.shopStorePayChannelList = res.page.list;
                    this.totalNum = res.page.total;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        getShopStorePayChannelById() {
            get(`/shop/storepaychannel/get`, { id: this.currentShopStorePayChannelId }).then((res) => {
                if (res.success) {
                    this.shopStorePayChannel = { ...this.shopStorePayChannel, ...res.shopStorePayChannel };
                    this.isGet = true
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        /**
         * 导出信息
         */
        exportShopStorePayChannelList() {
            //this.btnLoading = true;
            exprotExcel(`/shop/storepaychannel/export`, { ...this.queryForm });
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/shop/storepaychannel/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/shop/storepaychannel/importData`, formData);
            this.refreshShopStorePayChannelList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getShopStorePayChannelList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getShopStorePayChannelList();
        }
    }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
.active{
    color:#67C23A;
}
</style>